import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzToggleSwitchModule } from '@blk/daisy/elements/selection-controls';
import { DzModalModule } from '@blk/daisy/modules/modals';
import { AdvisoryFeeModule } from '@ddt-web/advisory-fee';
import { AnalyticsModule } from '@ddt-web/analytics';
import { ChartModule } from '@ddt-web/chart';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { DcrModule } from '@ddt-web/dcr';
import { DialogService } from '@ddt-web/dialog';
import { DisclosureModule } from '@ddt-web/disclosure';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { NewChartModule } from '@ddt-web/highchart-manager';
import { StoreService } from '@ddt-web/store-service';

import { CustomizeDollarAmountDialogComponent } from './components/customize-dollar-amount-dialog/customize-dollar-amount-dialog.component';
import { MarketMovesComponent } from './components/market-moves';
import { ScenarioAnalysisComponent } from './components/scenario-analysis/scenario-analysis.component';
import { ScenarioSelectionDialogComponent } from './components/scenario-selection-dialog/scenario-selection-dialog.component';
import { ScenariosChartTableComponent } from './components/scenarios-chart-table/scenarios-chart-table.component';
import { SimpleScenarioSelectionDialogComponent } from './components/simple-scenario-selection-dialog/simple-scenario-selection-dialog.component';
import { SimpleScenariosTableComponent } from './components/simple-scenarios-table/simple-scenarios-table.component';
import { MdsGroupDetailsComponent } from './scenario-details/mds-group-details/mds-group-details.component';
import { MdsScenarioComponent } from './scenario/mds-scenario';
import { ScenarioCategoryComponent } from './scenario/scenario-category/scenario-category.component';
import { ScenarioComponent } from './scenario/scenario.component';
import { ScenarioService } from './services/scenario.service';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CommonModule,
		GenericDirectivesModule,
		AnalyticsModule,
		MatButtonModule,
		DcrModule,
		SharedModule,
		DataServiceModule,
		DisclosureModule,
		CwpNgFrameworkModule,
		NewChartModule,
		ChartModule,
		DzButtonModule,
		DzToggleSwitchModule,
		DomModule,
		AdvisoryFeeModule,
		DzModalModule
	],
	declarations: [
		ScenarioComponent,
		ScenarioCategoryComponent,
		CustomizeDollarAmountDialogComponent,
		ScenarioSelectionDialogComponent,
		MarketMovesComponent,
		ScenarioAnalysisComponent,
		MdsScenarioComponent,
		MdsGroupDetailsComponent,
		SimpleScenariosTableComponent,
		ScenariosChartTableComponent,
		SimpleScenarioSelectionDialogComponent
	],
	providers: [ScenarioService, MatDialog, StoreService, DialogService],
	exports: [
		ScenarioComponent,
		ScenarioCategoryComponent,
		CustomizeDollarAmountDialogComponent,
		ScenarioSelectionDialogComponent,
		SimpleScenarioSelectionDialogComponent,
		MarketMovesComponent,
		ScenarioAnalysisComponent,
		MdsScenarioComponent,
		MdsGroupDetailsComponent,
		SimpleScenariosTableComponent,
		ScenariosChartTableComponent
	]
})
export class ScenariosModule { }
